import { IInitialState } from 'src/store/initialState';

const allDashboardViewSelector = (
  state: IInitialState
): IInitialState['dashboardView'] => state.dashboardView;

export const dashboardViewMenuOptionSel = (state: IInitialState) =>
  allDashboardViewSelector(state).menuOption;
export const dashboardViewIsPendingSel = (state: any) =>
  allDashboardViewSelector(state).isPending;
export const dashboardViewErrorSel = (state: any) =>
  allDashboardViewSelector(state).error;
export const dashboardViewPowerUsersSel = (state: any) =>
  allDashboardViewSelector(state).powerUsers;
export const dashboardViewHasSucceedSel = (state: any) =>
  allDashboardViewSelector(state).hasSucceed;
export const dashboardCurrentPasswordSel = (state: any) =>
  allDashboardViewSelector(state).currentPassword;
export const dashboardNewPasswordSel = (state: any) =>
  allDashboardViewSelector(state).newPassword;
export const dashboardNewPasswordRepeatSel = (state: any) =>
  allDashboardViewSelector(state).newPasswordRepeat;
export const dashboardNewPasswordValidationSel = (state: any) =>
  allDashboardViewSelector(state).newPasswordValidation;
  export const dashboardViewEcheckDisabledUsersSel = (state: any) =>
  allDashboardViewSelector(state).echeckDisabledUsers;

export const unlockUserValidationSel = (state: any) =>
  allDashboardViewSelector(state).unlockUser;
